module.exports = __webpack_public_path__ + "static/media/share-icon.a234b716.svg";